export const FLASH_MESSAGE_ACTION_TYPE = '@@redux-flash/FLASH'
export const CLEAR_MESSAGES_ACTION_TYPE = '@@redux-flash/CLEAR_MESSAGES'
export const REMOVE_MESSAGE_ACTION_TYPE = '@@redux-flash/REMOVE_MESSAGE'
export const ADD_MESSAGE_ACTION_TYPE = '@@redux-flash/ADD_MESSAGE'

// This action will be picked up by the middleware
export const flashMessage = (message, options = {}) => {
  return {
    type: FLASH_MESSAGE_ACTION_TYPE,
    payload: {
      message,
      options,
    }
  }
}

// Pure actions

export const clearMessages = () => ({ type: CLEAR_MESSAGES_ACTION_TYPE })
export const removeMessage = (payload) => ({ type: REMOVE_MESSAGE_ACTION_TYPE, payload })

// Internal actions

export const _addMessage = (payload) => ({ type: ADD_MESSAGE_ACTION_TYPE, payload })

// Aliases 
export const flashSuccessMessage = flashMessage

export const flashErrorMessage = (message, options) => {
  return flashMessage(message, { isError: true, ...options })
}
